module.exports = __webpack_public_path__ + "media/images/offer-webpage-c0726c1f7d344253a26932323ade2ccb.png";